import { api } from './apiProvider';

export interface PaymentSettings {
  canAcceptCard: boolean;
  canAcceptAch: boolean;
  stripeAccountId: string;
  stripePublishableKey: string;
  onlinePaymentsEnabled: boolean;
  surchargingEnabled: boolean;
}

export async function getPaymentSettings(): Promise<PaymentSettings> {
  return await api
    .get('payment-settings', {
      credentials: 'include',
    })
    .json<PaymentSettings>();
}
